




























import { Locale } from 'vue-i18n';
import { Component, Vue } from 'vue-property-decorator';
import {
  updateLanguage,
  updateUsageFavorite,
} from '@/appsync/service/LoginUserMutationService';
import { getSystemSettingInfoIfNotCreate } from '@/appsync/service/SystemSettingQueryService';
import { refreshStores } from '@/containers/globals/globalSharedService';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import SettingBody from '@/containers/templates/SettingBody.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import { UserInfo, LoginInfo } from '@/types/type';
import {
  _BooleanEnum2boolean,
  returnFalseIfNilElseProcess,
} from '@/utils/CommonUtils';
import { SNACKBAR_TIMEOUT } from '@/utils/consts';

@Component({
  components: { PortalAppBar, SettingBody },
})
export default class Setting extends Vue {
  private loading: boolean = true;
  private savedMessage: boolean = false;
  private isMultilanguageEnabled: boolean = true;
  private isPortalEnabled: boolean = false;
  private snackbarTimeout: number = SNACKBAR_TIMEOUT;

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    await refreshStores(commonModule.loginInfo);
    const systemSettingInfo = await getSystemSettingInfoIfNotCreate(
      loginInfo.tenant,
      loginInfo.landscape
    );
    this.isMultilanguageEnabled = systemSettingInfo.isMultilanguageEnabled;
    this.isPortalEnabled = systemSettingInfo.isPortalEnabled;
    this.loading = false;
  }

  private get pageTitle(): string {
    return i18n.tc('appbar.setting');
  }

  private get updatedMessage(): string {
    return i18n.tc('setting.updatedMessage');
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private get loginInfo(): LoginInfo {
    return commonModule.loginInfo;
  }

  private async changeUsageFavorite(usage: boolean): Promise<void> {
    await updateUsageFavorite({ ...commonModule.loginInfo, usage });
    await refreshStores(commonModule.loginInfo, {
      forceReload: { userInfo: true },
    });
    this.savedMessage = true;
  }

  private async changeLanguage(language: Locale): Promise<void> {
    await updateLanguage({ ...commonModule.loginInfo, language });
    await refreshStores(commonModule.loginInfo, {
      forceReload: { userInfo: true },
    });
    loginUserModule.setUserInfo({ ...loginUserModule.userInfo, language });
    this.savedMessage = true;
  }
}
